import { gql, useQuery } from '@apollo/client';
import React from 'react';

import { Loading } from 'src/components/common/loading/Loading';
import { NotFound } from 'src/components/common/notFound/NotFound';
import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { GraphRef } from '../../hooks/useGraphRef';

import {
  ApprovalsAndPermissionsCard,
  ApprovalsAndPermissionsCardFragment,
} from './approvalsAndPermissionsCard/ApprovalsAndPermissionsCard';
import {
  ProposalDescriptionTemplateCard,
  ProposalDescriptionTemplateCardFragment,
} from './descriptionTemplateSection/ProposalDescriptionTemplateCard';
import { ProposalImplementationCard } from './ProposalImplementationCard';

export const ProposalsPage = ({ graphRef }: { graphRef: GraphRef }) => {
  const { data, loading } = useQuery<
    GraphQLTypes.ProposalsPageQuery,
    GraphQLTypes.ProposalsPageQueryVariables
  >(
    gql`
      query ProposalsPageQuery($graphId: ID!) {
        service(id: $graphId) {
          id
          ...ApprovalsAndPermissionsCardFragment
          ...ProposalDescriptionTemplateCardFragment
        }
      }
      ${ApprovalsAndPermissionsCardFragment}
      ${ProposalDescriptionTemplateCardFragment}
    `,
    {
      context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
      variables: {
        graphId: graphRef.graphId,
      },
    },
  );

  if (loading) {
    return <Loading />;
  }

  if (!data?.service) {
    return <NotFound />;
  }

  return (
    <>
      <ApprovalsAndPermissionsCard graph={data.service} />
      <ProposalDescriptionTemplateCard graph={data.service} />
      <ProposalImplementationCard />
    </>
  );
};
